import { GroupResource, ProfileGroupStatus } from '@foxbun/lib-goferal-types';
import { AbstractModelOptions } from '../stores/models/abstract/AbstractModelStore';
import { generatePath } from 'react-router-dom';
import { observable } from 'mobx';
import { Routing } from '../../pages/Routing';
import { ResourceModel } from './ResourceModel';

export class GroupModel extends ResourceModel<GroupResource> {
  @observable
  accessor my_status_loading: boolean;

  @observable
  accessor my_status: ProfileGroupStatus | null;

  constructor(options: AbstractModelOptions<GroupResource>) {
    super(options);
    this.my_status_loading = false;
    this.my_status = null;
  }

  get link() {
    return generatePath(Routing.GROUP, {
      id: this.data._id.toString()
    });
  }

  async refresh() {
    this.setData(await this.options.api_client.groups.getGroup({ _id: this.id }));
  }

  async loadMyRelation() {
    this.my_status_loading = true;
    try {
      this.my_status = await this.options.api_client.groups.getMyGroupStatus({
        _id: this.id
      });
    } finally {
      this.my_status_loading = false;
    }
  }

  async join() {
    await this.options.api_client.groups.joinGroup({
      _id: this.id
    });
    await this.loadMyRelation();
  }

  async leave() {
    let res = this.options.api_client.groups.leaveGroup({
      _id: this.id
    });
  }
}
